import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // You'll create this file

const store = configureStore({
    reducer: rootReducer,
    // Add middleware, enhancers, and other store configurations as needed
});

export default store;